import zainLogo from './logos/zain.svg';
// png, not svg: the svg wordmark from the assets folder is invalid XML and
// browsers show a broken-image icon for it
import mobilyLogo from './logos/mobily.png';
import stcLogo from './logos/stc.svg';
import lebaraLogo from './logos/lebara.svg';
import redbullLogo from './logos/redbull.svg';
import zainSdLogo from './logos/zain-sd.png';
import mtnLogo from './logos/mtn.jpg';
import sudaniLogo from './logos/sudani.jpg';
import visaLogo from './logos/visa.png';

// Payment method ids come from usePaymentMethods(), which is driven by the
// billing settings — the ids are a fixed, known set, so the logo for each is a
// static lookup. Ids with no artwork here fall back to a lettered tile.
export const paymentMethodLogos: Record<string, string> = {
  phonesub: zainLogo, // Zain KSA
  zain_sd: zainSdLogo, // Zain Sudan (distinct silver wordmark)
  mobily: mobilyLogo,
  stc: stcLogo,
  lebara: lebaraLogo,
  redbull: redbullLogo,
  MTN_sd: mtnLogo,
  sudani_spay: sudaniLogo,
  // card payments run through the stripe gateway; the card shows the Visa mark
  stripe: visaLogo,
};

// wordmarks are wide and short, so they need a wider tile than square marks
export const wideLogoMethods = new Set([
  'lebara',
  'redbull',
  'mobily',
  'zain_sd',
  'stripe',
]);

// Arabic-first operator names shown on the pricing grid cards; ids missing
// here fall back to the English name from usePaymentMethods()
export const paymentMethodDisplayNames: Record<string, string> = {
  phonesub: 'زين',
  zain_sd: 'زين',
  mobily: 'موبايلي',
  stc: 'STC',
  lebara: 'ليبارا',
  redbull: 'ريد بُل',
  sudani_spay: 'سوداني',
  MTN_sd: 'MTN',
  stripe: 'الدفع بالبطاقة',
};
